import { useReducer, useEffect } from 'react';
import { produce } from 'immer';
import Raven from 'raven-js';
import RequestStatusTypes from 'settings-ui-lib/constants/RequestStatusTypes';
import CRMSearchAPI from '../api/crmSearch';
import { contactsRegistrationCountActionTypes } from '../constants/ActionTypes';
const initialState = {
  count: 0,
  requestStatus: RequestStatusTypes.UNINITIALIZED
};
const contactsRegistrationCountRequested = () => ({
  type: contactsRegistrationCountActionTypes.PENDING
});
const contactsRegistrationCountReceived = count => ({
  type: contactsRegistrationCountActionTypes.SUCCEEDED,
  count
});
const contactsRegistrationCountFailed = () => ({
  type: contactsRegistrationCountActionTypes.FAILED
});
const contactsRegistrationCountReducer = (state = initialState, action) => {
  switch (action.type) {
    case contactsRegistrationCountActionTypes.PENDING:
      return produce(state, draft => {
        draft.requestStatus = RequestStatusTypes.PENDING;
      });
    case contactsRegistrationCountActionTypes.SUCCEEDED:
      return produce(state, draft => {
        draft.requestStatus = RequestStatusTypes.SUCCEEDED;
        draft.count = action.count;
      });
    case contactsRegistrationCountActionTypes.FAILED:
      return produce(state, draft => {
        draft.requestStatus = RequestStatusTypes.FAILED;
      });
    default:
      return state;
  }
};
export default (({
  ilsListIds,
  isRegistered,
  shouldFetchData = true
}) => {
  const [state, dispatch] = useReducer(contactsRegistrationCountReducer, initialState);
  const onSuccess = response => {
    dispatch(contactsRegistrationCountReceived(response.count));
  };
  const onError = error => {
    dispatch(contactsRegistrationCountFailed());
    Raven.captureException(error, {
      extra: {
        message: 'Contacts registration count fetch failed in ui-memberships-settings-lib'
      }
    });
  };
  useEffect(() => {
    let mounted = true;
    if (mounted && ilsListIds.length && shouldFetchData) {
      dispatch(contactsRegistrationCountRequested());
      CRMSearchAPI.getContactsRegistrationCount(ilsListIds, isRegistered).then(onSuccess).catch(onError);
    }
    return () => {
      mounted = false;
    };
  }, [ilsListIds, isRegistered, shouldFetchData]);
  if (!ilsListIds.length) {
    return {
      contactsRegistrationCountRequestStatus: RequestStatusTypes.SUCCEEDED,
      count: 0,
      isRegistered
    };
  }
  return {
    contactsRegistrationCountRequestStatus: state.requestStatus,
    count: state.count,
    isRegistered
  };
});